import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

const Layout = ({ children }) => {
  const [username, setUsername] = useState("");
  const [avatarUrl, setAvatarUrl] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
      return;
    }

    const fetchUser = async () => {
      try {
        const resUser = await fetch(`${process.env.REACT_APP_API_URL}/users/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!resUser.ok) {
          navigate("/");
          return;
        }

        const userData = await resUser.json();
        setUsername(userData.username);

        // 再取得 profile 包含 avatar_url
        const resProfile = await fetch(`${process.env.REACT_APP_API_URL}/users/me/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (resProfile.ok) {
          const profileData = await resProfile.json();
          setAvatarUrl(profileData.avatar_url);
        }
      } catch (error) {
        console.error("Failed to get user or profile:", error);
        navigate("/");
      }
    };

    fetchUser();
  }, [navigate]);

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  const displayAvatar = avatarUrl?.startsWith("http")
    ? avatarUrl
    : `${process.env.REACT_APP_API_URL}${avatarUrl}`;

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="bg-[#feb053] text-white shadow px-4 py-2 flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-4">
        <Link to="/dashboard" className="flex items-center">
          <img
            src="/logo.png"
            alt="TripsFlare Logo"
            className="h-12 sm:h-16 object-contain max-w-full"
          />
        </Link>
        <div className="flex items-center gap-2 sm:gap-4">
          {username && (
            <Link to="/profile" className="hover:opacity-80">
              <img
                src={displayAvatar}
                alt="User Avatar"
                className="w-9 h-9 sm:w-10 sm:h-10 rounded-full object-cover border-2 border-white"
              />
            </Link>
          )}
          <button
            onClick={logout}
            className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 sm:px-4 sm:py-2 rounded text-sm sm:text-base"
          >
            Sign out
          </button>
        </div>
      </div>

      {/* Content */}
      <main className="p-4 sm:p-6 max-w-7xl mx-auto w-full">{children}</main>
    </div>
  );
};

export default Layout;
